import { service } from '@ember/service';
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import ContactsCache from 'donor-elf-web/services/contacts-cache';
import { type BulkActionsContactsChangedArgs } from '../..';

interface ComponentArgs {
  propertyLabel: string;
  contactIds: string[];
  onContactsChanged: (args: BulkActionsContactsChangedArgs) => void;
  onClose: () => void;
}

export default class ContactBulkActionsEditPropertyExistingIndexComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;

  get isReadonlyProperty() {
    return this.propertyInfo?.r === true;
  }

  get isGroupsProperty() {
    return this.args.propertyLabel === 'Groups';
  }

  @cached
  get propertyInfo() {
    if (this.isGroupsProperty) {
      return undefined;
    } else {
      return this.contactsCache.customPropertiesByLowecaseLabel[
        this.args.propertyLabel.toLowerCase()
      ];
    }
  }

  get propertyInfoTypeIsList() {
    return (
      this.isGroupsProperty ||
      (this.propertyInfo!.t === 'l' &&
        this.propertyInfo!.s?.single_selection !== true)
    );
  }
}
